import { modalUser } from '@organisms/user/modals/modal-user';
import { initProfileOrganization } from '@organisms/user/profile/organization/main';
import { resettingPassword } from '@organisms/user/profile/resetting-password';

export const initUser = () => {
  resettingPassword();

  if (
    document.querySelector('header')
    && document.querySelector('.modal-user')
  ) {
    modalUser('.modal-user');
  }

  if (document.getElementById('user-profile-team')) {
    initProfileOrganization();
  }
};
